import * as React from 'react';

import { CourseLink, CourseLinkProps } from './CourseLink'

export function PublicCourseLink(props:CourseLinkProps) {
  return <CourseLink role='public' {...props} />
}

PublicCourseLink.fieldProps = CourseLink.fieldProps
